export default {
  zh: {
    dayText: '天',
    LiveTime: '直播记录',
    Durationonmic: '在麦时长',
    totallivetime: '总开播时长',
    bigTwoTime: '>=2小时',
    date: '日期',
    received_coins: '收到的硬币',
    total_received_coins: '总收硬币'
  },
  ar: {
    dayText: 'أيام',
    LiveTime: 'سجل البث',
    Durationonmic: 'ساعة اليومي ',
    totallivetime: 'إجمالي الوقت ',
    bigTwoTime: 'ايام فعالية',
    date: 'التاريخ',
    received_coins: 'تارجت ',
    total_received_coins: 'تارجت اجمالي '
  },
  tr: {
    dayText: 'Gün',
    LiveTime: 'Yaşam Rekoru',
    Durationonmic: 'Mikrofondaki Süre',
    totallivetime: 'Toplam Aktif Süre',
    bigTwoTime: '>=2 Saat',
    date: 'Tarih',
    received_coins: 'Alınan Altınlar ',
    total_received_coins: 'Toplam Alınan Altınlar'
  },
  en: {
    dayText: 'days',
    LiveTime: 'Living record',
    Durationonmic: 'Duration on mic',
    totallivetime: 'Total live time',
    bigTwoTime: '>=2 hours',
    date: 'Date',
    received_coins: 'Received coins',
    total_received_coins: 'Total received coins'
  },
  uz: {
    dayText: 'kunlar',
    LiveTime: 'Yashash qaydnomasi',
    Durationonmic: 'Mikrofonning davomiyligi',
    totallivetime: 'Jami jonli vaqt',
    bigTwoTime: '>=2 soat',
    date: 'Sana',
    received_coins: 'Qabul qilingan tangalar',
    total_received_coins: 'Jami qabul qilingan tangalar'
  },
  ru: {
    dayText: 'дни',
    LiveTime: 'Запись жизни',
    Durationonmic: 'Продолжительность на микрофоне',
    totallivetime: 'Общее время в эфире',
    bigTwoTime: '>=2 часа',
    date: 'Дата',
    received_coins: 'Полученные монеты',
    total_received_coins: 'Всего полученные монеты'
  },
  fa: {
    dayText: 'روزها',
    LiveTime: 'ثبت زندگی',
    Durationonmic: 'مدت زمان در میکروفن',
    totallivetime: 'کل زمان پخش زنده',
    bigTwoTime: '>=2 ساعت',
    date: 'تاریخ',
    received_coins: 'سکه‌های دریافت شده',
    total_received_coins: 'کل سکه‌های دریافت شده'
  },
  pt: {
    dayText: 'dias',
    LiveTime: 'Registro de vida',
    Durationonmic: 'Duração no microfone',
    totallivetime: 'Tempo total ao vivo',
    bigTwoTime: '>=2 horas',
    date: 'Data',
    received_coins: 'Moedas recebidas',
    total_received_coins: 'Total de moedas recebidas'
  },
  id: {
    dayText: 'hari',
    LiveTime: 'Rekam hidup',
    Durationonmic: 'Durasi di mikrofon',
    totallivetime: 'Total waktu siaran langsung',
    bigTwoTime: '>=2 jam',
    date: 'Tanggal',
    received_coins: 'Koin yang diterima',
    total_received_coins: 'Total koin yang diterima'
  },
  ur: {
    dayText: 'دن',
    LiveTime: 'لائیو ریکارڈ',
    Durationonmic: 'مائیک پر دورانیہ',
    totallivetime: 'کل لائیو وقت',
    bigTwoTime: '≥2 گھنٹے',
    date: 'تاریخ',
    received_coins: 'موصولہ سکے',
    total_received_coins: 'کل موصولہ سکے'
  }
}



// WEBPACK FOOTER //
// src/pages/app/livetimeMic/lang.js